<style lang="postcss">
.grow {
	display: grid;
}
.grow::after {
	content: attr(data-replicated-value) " ";
	white-space: pre-wrap;
	visibility: hidden;
}
.grow > textarea {
	resize: none;
	overflow: hidden;
}
.grow > textarea,
.grow::after {
	font: inherit;
	grid-area: 1 / 1 / 2 / 2;
	@apply px-3 py-2;
}
</style>

<script lang="ts">
import { onMount } from "svelte";

export let field: FieldDisplay | Field;
export let element: HTMLTextAreaElement = {} as HTMLTextAreaElement;
export let value: string = "";
let parentNode: HTMLElement = {} as HTMLElement;
const onInput = (e: Event) => {
	const target = e.target as HTMLTextAreaElement;
	parentNode.dataset.replicatedValue = target.value;
};
onMount(() => {
	parentNode.dataset.replicatedValue = value;
});
</script>

{#if field.type !== "RichText"}
	{#if "labelComputed" in field}
		<div class="grow" bind:this="{parentNode}">
			<textarea
				{...$$restProps}
				bind:this="{element}"
				bind:value="{value}"
				name="{field.id}"
				aria-label="{field.labelComputed || field.label}"
				class="{$$props.class || ''} field-input"
				on:input="{onInput}"></textarea>
		</div>
	{:else}
		<div class="grow" bind:this="{parentNode}">
			<textarea
				{...$$restProps}
				bind:this="{element}"
				bind:value="{value}"
				name="{field.id}"
				class="{$$props.class || ''} field-input"></textarea>
		</div>
	{/if}
{/if}
